import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileFormComponent } from './profile-form.component';
import { ImageUploadModule } from '@components/form-group/image-upload/image-upload.module';
import { PhoneInputModule } from '@components/form-group/phone-input/phone-input.module';
import { InputModule } from '../form-group/input/input.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ProfileFormComponent],
  imports: [
    CommonModule,
    ImageUploadModule,
    PhoneInputModule,
    InputModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ProfileFormComponent
  ]
})
export class ProfileFormModule { }
